export default __webpack_public_path__ + "static/media/campfire_logo.a0dbe9fd.png";